export const ADMIN_LIST = "ADMIN_LIST";
export const USER_DETAIL = "USER_DETAIL";